import { render } from "./PhoneNumber.vue?vue&type=template&id=1dbc8c74"
import script from "./PhoneNumber.vue?vue&type=script&lang=ts"
export * from "./PhoneNumber.vue?vue&type=script&lang=ts"
script.render = render

export default script